import useSWR from 'swr'

import { MeetingsAPI } from 'api'

const fetcher = (url: string) =>
  MeetingsAPI.get<number[]>(`/scheduling/settings/connected`).then(
    (res) => res.data
  )

export const useConnectedCalendarIds = () => {
  const { data } = useSWR<number[]>(`/scheduling/settings/connected`, fetcher)
  return data
}
